(function () {
  function initShowcase(section) {
    if (!section || section.dataset.lgWorkShowcaseReady === 'true') return;
    section.dataset.lgWorkShowcaseReady = 'true';

    var triggers = Array.prototype.slice.call(section.querySelectorAll('[data-lg-work-image]'));
    var lightbox = section.querySelector('[data-lg-work-lightbox]');
    var image = section.querySelector('[data-lg-work-lightbox-image]');
    var closeButton = section.querySelector('[data-lg-work-close]');
    var prevButton = section.querySelector('[data-lg-work-prev]');
    var nextButton = section.querySelector('[data-lg-work-next]');
    var backdrop = section.querySelector('[data-lg-work-backdrop]');
    var counter = section.querySelector('[data-lg-work-counter]');
    var rail = section.querySelector('[data-lg-work-rail]');
    var railPrevButton = section.querySelector('[data-lg-work-scroll-prev]');
    var railNextButton = section.querySelector('[data-lg-work-scroll-next]');
    var currentIndex = 0;
    var lastFocused = null;

    if (!triggers.length || !lightbox || !image || !closeButton) return;

    function getRailStep() {
      if (!rail) return 0;
      return Math.max(rail.clientWidth, 0);
    }

    function updateRailButtons() {
      if (!rail || !railPrevButton || !railNextButton) return;

      var maxScroll = rail.scrollWidth - rail.clientWidth - 2;
      railPrevButton.disabled = rail.scrollLeft <= 2;
      railNextButton.disabled = rail.scrollLeft >= maxScroll;
    }

    function scrollRail(direction) {
      if (!rail) return;
      rail.scrollBy({
        left: getRailStep() * direction,
        behavior: 'smooth'
      });
    }

    function setImage(index) {
      currentIndex = (index + triggers.length) % triggers.length;
      var trigger = triggers[currentIndex];
      image.src = trigger.dataset.fullSrc || trigger.dataset.lgWorkImage || '';
      image.alt = trigger.dataset.alt || '';

      if (counter) {
        counter.textContent = currentIndex + 1 + ' / ' + triggers.length;
      }
    }

    function openLightbox(index) {
      lastFocused = document.activeElement;
      setImage(index);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lg-work-showcase-lock');
      closeButton.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lg-work-showcase-lock');
      image.removeAttribute('src');

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function showPrevious() {
      setImage(currentIndex - 1);
    }

    function showNext() {
      setImage(currentIndex + 1);
    }

    function trapFocus(event) {
      if (event.key !== 'Tab' || lightbox.hidden) return;

      var focusable = Array.prototype.slice.call(
        lightbox.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.offsetParent !== null;
      });

      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        openLightbox(index);
      });
    });

    closeButton.addEventListener('click', closeLightbox);
    if (backdrop) backdrop.addEventListener('click', closeLightbox);

    if (prevButton) prevButton.addEventListener('click', showPrevious);
    if (nextButton) nextButton.addEventListener('click', showNext);
    if (railPrevButton) railPrevButton.addEventListener('click', function () { scrollRail(-1); });
    if (railNextButton) railNextButton.addEventListener('click', function () { scrollRail(1); });
    if (rail) rail.addEventListener('scroll', updateRailButtons);
    window.addEventListener('resize', updateRailButtons);
    updateRailButtons();

    section.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
      }

      if (triggers.length > 1 && event.key === 'ArrowLeft') {
        event.preventDefault();
        showPrevious();
      }

      if (triggers.length > 1 && event.key === 'ArrowRight') {
        event.preventDefault();
        showNext();
      }

      trapFocus(event);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lg-work-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initShowcase(event.target.querySelector('[data-lg-work-showcase]'));
  });
})();
